<template>
  <v-container>
    <v-row align="center">
      <v-col
        v-for="(link, i) in links"
        :key="i"
        class="text-center"
        cols="6"
        md="auto"
      >
        <router-link
          :to="link.href"
          class="
            text-decoration-none text-uppercase text-caption
            font-weight-regular
          "
          rel="noopener"
          v-text="link.text"
        />
      </v-col>

      <v-spacer class="hidden-sm-and-down" />

      <v-col
        cols="12"
        md="auto"
      >
        <div class="text-body-1 font-weight-light pt-6 pt-md-0 text-center">
          &copy; {{ new Date().getFullYear() }}, Feito por Campagnolo Software
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Links',

    data: () => ({
      isDev: process.env.NODE_ENV === 'development',
      apiUrl: process.env.VUE_APP_API_URL,

      links: [
        {
          href: '/',
          text: 'Painel',
        },
        {
          href: '/clientes',
          text: 'Clientes',
        },
        {
          href: '/pedidos',
          text: 'Pedidos',
        },
        {
          href: '/agenda',
          text: 'Agenda',
        },
      ],
    }),
  }
</script>

<style lang="sass" scoped>
a
  color: inherit !important
</style>
